import { eventEmitter as event, parsePulseCookies as parse } from './pulse-cookie';
import { syncWithCis as sync } from './cis';

export var syncWithCis = sync;
export var eventEmitter = event;
export var parsePulseCookie = parse;